module.exports = __webpack_public_path__ + "img/00-home.56ff1246.svg";